import {createApi, fetchBaseQuery, retry} from '@reduxjs/toolkit/query/react';
import {oktaAuth} from '../components/Okta/AuthService';

const staggeredBaseQuery = retry(
  fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: async (headers, {getState}) => {
      const tokenObj = await oktaAuth.tokenManager.get('accessToken');
      const token = tokenObj?.accessToken;
      if (token) headers.set('authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  {maxRetries: 3},
);

export const powerBiApi = createApi({
  reducerPath: 'powerBiApi', // This key must match what you added in store.js
  baseQuery: staggeredBaseQuery,
  endpoints: (builder) => ({
    getEmbedConfig: builder.query({
      query: ({email, role}) => ({
        url: '',
        method: 'GET',
        params: {
          code: 'ohAKCfeKxKE-yCv_jf7E4TvA6tvncsIFm79jmzVLtQYtAzFu6PmFUA==',
          email: email,
          role: role,
          type: 'embed',
        },
      }),
      keepUnusedDataFor: 50 * 60,
    }),
  }),
});

export const {useGetEmbedConfigQuery} = powerBiApi;
